
import Store from '../store/Store'
import Vue from 'vue'
import AlertHelpers from '../helpers/AlertHelpers'
import Utilities from './Utilities'
import Firebase from 'firebase/app'
import 'firebase/firestore'
import Firestore from '../data/Firestore'
import NiceData from '../data/NiceData'
import DataHelpers from './DataHelpers'


const testEmail = {
    SecureToken: "141b017c-9734-42db-a768-4a8feda70363",
    To: "matt.ireland@mortgagechoice.com.au",
    From: "matt@ireland.mx",
    FromName: 'Matt Ireland',
    ReplyAddress: 'matt.ireland.home@gmail.com',
    Subject: "Testing 456",
    Body: "this is the body (with attachments).",
    Attachments: [
        {
            name: "MyTestPDF.pdf",
            path: "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-LO0RZ0J2WW6PAhSfLR2%2Fdoc20180928120918.pdf?alt=media&token=ef696acf-5a0a-4e34-b015-46ae670c81b4"
        },
        {
            name: "ANZ.jpg",
            path: "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-LO0RZ0J2WW6PAhSfLR2%2FANZ.jpg?alt=media&token=147ca574-4cb8-45a9-a825-d16a67391746"
        },
    ]
}

export default class {

static sendTest() {
    this.sendEmail({
        to: 'matt.ireland@mortgagechoice.com.au',
        from: 'matt@ireland.mx',
        subject: 'Testing ABC',
        body: 'This is a <b>test</b> with html body',
        attachments: [
            {
                name: "MyTestPDF.pdf",
                path: "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-LO0RZ0J2WW6PAhSfLR2%2Fdoc20180928120918.pdf?alt=media&token=ef696acf-5a0a-4e34-b015-46ae670c81b4"
            },
            {
                name: "ANZ.jpg",
                path: "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-LO0RZ0J2WW6PAhSfLR2%2FANZ.jpg?alt=media&token=147ca574-4cb8-45a9-a825-d16a67391746"
            },
        ]
    }).then(result => {
        AlertHelpers.showAlert('Email sent with message: ' + result)
    })

    //Email.send(testEmail).then(message => alert('The result was: ' + message))
}

static sendEmail(email) {
    const self = this
    return new Promise( (resolve, reject) => {

        let smtpEmail = {
            SecureToken: "141b017c-9734-42db-a768-4a8feda70363",

            From: email.from || Store.getters.user.email,
            FromName: email.fromName || Store.getters.userFullName,
            Subject: email.subject,
            Body: email.body + '<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><div style="text-align:center;padding:20px;color:#bbb;font-size:9px;">This message may contain legally privileged, confidential and/or copyrighted information. If you are not the intended recipient of this message, please immediately notify the sender and delete the email and any attachments, and any copies without dissemination or use. Receipt by an unintended recipient does not waive legal professional privilege. Any views expressed in this message are those of the individual  sender, except where the sender specifically, and with authority, states them to be the views of the sender or a related company. No representation, warranty or guarantee is made that this email or any attachment is free from viruses, errors, interference or other defect. This notice should not be deleted or altered. Message composed and sent via {accountaddress}. <a href="{unsubscribe}" style="color:#bbb!important;font-size:9px">Unsubscribe</a></div>',
        }
        if(email.to)
            smtpEmail.To = email.to
        if(email.cc)
            smtpEmail.Cc = email.cc
        if(email.bcc)
            smtpEmail.Bcc = email.bcc

        if(email.attachments)
            smtpEmail.Attachments = email.attachments

        if(email.reply)
            smtpEmail.ReplyAddress = email.reply

        Email.send(smtpEmail).then(message => {

            email.result = message
            if(message != 'OK') {
                debugger
                AlertHelpers.showAlert('Email failed: ' + message)
            }

            resolve(message)
        })

        if(email.copyMe) {
            debugger
            smtpEmail.body = '*** The following was sent to ' + smtpEmail.to.join(',') + '<BR/>' + smtpEmail.body
            smtpEmail.to = [DataHelpers.getUserEmail()]
            smtpEmail.cc = null
            smtpEmail.bcc = null
            smtpEmail.subject = 'TACO-SENT: ' + smtpEmail.subject
        }
    })
}

// static logEmail(email) {
//     let logItem = LogHelpers.createLogItem()
//     logItem.title = 'Email to ' + email.to
//     logItem.details = email.subject
//     logItem.type = 'send email'
//     logItem.data = email

//     if(email.result != 'OK')
//         logItem.title = 'FAILED: ' + logItem.title

//     LogHelpers.log(logItem)
// }

static sendEmailJS(email) {

    return new Promise( (resolve, reject) => {
        let service = email.service || 'default_service'
        let template = 'taco'

        let jsEmail = {}

        if(!email.to || !email.body || !email.subject) {
            console.error('Invalid email', email)
            return
        }

        let attachmentsString = ''

        if(email.attachments && email.attachments.length) {
            email.attachments.forEach(attachment => {
                const str = `<a href="${attachment.path}" style="display:inline-block;padding:10px;border-radius:4px;color:white;background-color:#1c75d2;text-decoration:none;margin:8px;" target="_blank">${attachment.name}</a>`
                attachmentsString += str
            })
        }

        jsEmail.body = email.body
        if(attachmentsString)
            jsEmail.body = attachmentsString + `<br/><br/>` + jsEmail.body


        jsEmail.to = email.to
        jsEmail.subject = email.subject || ''
        jsEmail.from = email.from || this.Store.getters.user.email
        jsEmail.reply = email.from
        jsEmail.fromName = email.fromName || this.Store.getters.userFullName

        emailjs.send(service, template, jsEmail).then(response => {
            resolve(response)
        })
    })
}

static emailViaCloudExtensions(to, from, fromName, subject, html, attachments) {

    const attachmentsHtml = this.attachmentsToHtml(attachments)

    let cloudEmail = {
        to: to.join(';'),
        from: `"${fromName}"<${from}>`,
        message: {
            subject: subject,
            html: attachmentsHtml + html,
        },
        _path: 'mail'
    }
    Firestore.saveItem(cloudEmail)
}

static queueEmail(email) {

    let mailLog = {}
    if(email.provider) {
        mailLog.provider = email.provider
        delete email.provider
    }

    mailLog.email = email
    mailLog._path = 'teams/global/collections/mail/data'
    mailLog.statuses = {queued: true, queued_date: new Date()}
    mailLog.activities = [{event: 'queued', time: new Date()}]
    mailLog._id = Firestore.getId()
    Firestore.saveItem(mailLog).then(result => {

    }).catch(err => {
        console.error(err, JSON.stringify(email))
        AlertHelpers.showAlert(err)
    })
    return mailLog._id
}

static attachmentsToHtml(attachments) {
    let attachmentsString = `
    <div>
    `
    attachments.forEach(attachment => {
        const str = `
        <a href="${attachment.path}" style="display:inline-block;padding:10px;border-radius:4px;color:white;background-color:#1c75d2;text-decoration:none;margin:8px;" target="_blank">
            ${attachment.name}
        </a>`
        attachmentsString += str
    })
    attachmentsString += `</div>`
    return attachmentsString
}

static emailButton(relativePath, text) {
    const path =  'https://taco.insightprocessing.com.au/' + relativePath
    return `
    <a href="${path}" target="_blank">
        <button style="background-color:#1c75d2;padding:8px 14px;border-radius:16px;font-size:14px;color:white;font-weight:500;letter-spacing:.0892857143em;justify-content:center;text-transform:uppercase;">
            ${text}
        </button>
    </a>`
}

static createEmail() {
    let email = {
        to: '',
        cc: '',
        bcc: '',
        from: '',
        fromName: '',
        reply: '',
        subject: '',
        body: ''
    }
    return email
}

}


// WEBPACK FOOTER //
// ./src/helpers/EmailHelpers.js